import React from 'react'

function YouTubeIcon(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 50 35"
      height="35"
      width="50"
      focusable="false"
      role="img"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>YouTubeIcon</title>
      <g clipPath="url(#clip0_584_307)">
        <path
          d="M48.8957 5.45903C48.6089 4.40389 48.0495 3.44195 47.2732 2.669C46.4968 1.89605 45.5306 1.33906 44.4707 1.0535C40.5907 0 24.9746 0 24.9746 0C24.9746 0 9.35785 0.0318888 5.47777 1.08539C4.41791 1.37097 3.45168 1.92799 2.67532 2.70097C1.89895 3.47395 1.33953 4.43593 1.05277 5.49111C-0.120861 12.3546 -0.576134 22.813 1.085 29.4019C1.37179 30.4571 1.93122 31.419 2.70759 32.192C3.48395 32.9649 4.45016 33.5219 5.51 33.8075C9.39008 34.861 25.0065 34.861 25.0065 34.861C25.0065 34.861 40.6227 34.861 44.5026 33.8075C45.5625 33.5219 46.5287 32.965 47.3051 32.192C48.0815 31.4191 48.641 30.4571 48.9278 29.4019C50.1657 22.5287 50.5471 12.0768 48.8957 5.45903Z"
          fill="#FF0000"
        />
        <path d="M20.0039 24.9005L32.9586 17.4304L20.0039 9.96021V24.9005Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_584_307">
          <rect width="50" height="35" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default YouTubeIcon
